import findResult, {
  findSelectedInCategory,
  removeItemByCode,
} from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import { deleteUsergroupActions } from '../constants';
import { findAllUserGroups } from './state';

const handleDeleteUsergroup = withDraft((draft, action) => {
  findAllUserGroups(draft, action).forEach((category) => {
    action.items.forEach(({ code }) => {
      const item = findResult(draft.userGroups, category, code);
      if (item) {
        item.destroyStatus = states.PENDING;
        item.destroyErrors = [];
      }
    });
  });
});

const handleDeleteUsergroupError = withDraft((draft, action) => {
  draft.deleteUserGroupOpen = false;
  findAllUserGroups(draft, action).forEach((category) => {
    action.items.forEach(({ code, error }) => {
      const item = findResult(draft.userGroups, category, code);
      if (item) {
        item.destroyStatus = states.ERROR;
        item.destroyErrors = [error];
      }
    });
  });
});

const handleDeleteUsergroupSuccess = withDraft((draft, action) => {
  draft.deleteUserGroupOpen = false;
  findAllUserGroups(draft, action).forEach((category) => {
    action.items.forEach(({ code }) => {
      const item = findResult(draft.userGroups, category, code);
      if (item) {
        draft.userGroups[category].results = removeItemByCode(draft.userGroups[category].results, item);
      }
    });
  });
});

const handleShowDeleteUsergroupsDialog = withDraft((draft, action) => {
  draft.deleteUserGroupOpen = true;
  draft.userGroups.deletion.results = findSelectedInCategory(
    draft.userGroups,
    action.category,
  );
});

const handleShowDeleteUsergroupDialog = withDraft((draft, action) => {
  draft.deleteUserGroupOpen = true;
  draft.userGroups.deletion.results = [action.userGroup];
});

const handleHideDeleteUsergroupDialog = withDraft((draft) => {
  draft.deleteUserGroupOpen = false;
  draft.userGroups.deletion.results = [];
});

export default {
  [deleteUsergroupActions.DELETE_USERGROUP]: handleDeleteUsergroup,
  [deleteUsergroupActions.DELETE_USERGROUP_ERROR]: handleDeleteUsergroupError,
  [deleteUsergroupActions.DELETE_USERGROUP_SUCCESS]: handleDeleteUsergroupSuccess,
  [deleteUsergroupActions.SHOW_DELETE_USERGROUPS_DIALOG]: handleShowDeleteUsergroupsDialog,
  [deleteUsergroupActions.SHOW_DELETE_USERGROUP_DIALOG]: handleShowDeleteUsergroupDialog,
  [deleteUsergroupActions.HIDE_DELETE_USERGROUP_DIALOG]: handleHideDeleteUsergroupDialog,
};
